export enum CargoType {
  'DOCUMENTS' = 'Документи',
  'CARGO' = 'Вантаж',
  'PARCEL' = 'Посилка',
  'DOORSDOORS' = 'Адреса → Адреса',
  'WAREHOUSEDOORS' = 'Відділення → Адреса',
  'DOORSWAREHOUSE' = 'Адреса → Відділення',
  'WAREHOUSEWAREHOUSE' = 'Відділення → Відділення',
  'MONEY' = 'Післяплата',
  'OTHER' = 'Інше',
  'PALLET' = 'Палети',
  'TIRESWHEELS' = 'Шини та диски',
}

export enum ServiceTypeParts {
  DOORS = 'Doors',
  WAREHOUSE = 'Warehouse',
}

export enum ServiceType {
  DOORS_WAREHOUSE = 'DoorsWarehouse',
  WAREHOUSE_WAREHOUSE = 'WarehouseWarehouse',
  DOORS_DOORS = 'DoorsDoors',
  WAREHOUSE_DOORS = 'WarehouseDoors',
}

export enum CargoTypes {
  PALLET = 'Pallet',
  TIRES_WHEELS = 'TiresWheels'
}

export enum InvoiceType {
  MY = 'my',
  IN = 'in',
  OUT = 'out',
  REGISTER = 'register',
  ARCHIVED = 'archived',
  TRASHCAN = 'trashcan',
}
